import { useActor } from '@xstate/react';
import { ReleaseMachineActor } from '../../../machines/Eligibility/ReleaseMachine';
import { ReleaseView } from './ReleaseView';

export function ReleaseController({ actor }: { actor: ReleaseMachineActor }) {
  const [state, send] = useActor(actor);

  return <ReleaseView state={state} send={send} />;
}
